var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17.03125,
    height: 16.12207,
    viewBox: "0 0 17.0312 16.1221",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u0418\\u043A\\u043E\\u043D\\u043A\\u0430 \\u0443\\u0434\\u0430\\u043B\\u0438\\u0442\\u044C",
    d: "M0.92 0.87L8.51 8.06L16.1 15.24M8.51 8.06L16.1 0.87M8.51 8.06L0.92 15.24",
    stroke: "#718EBF",
    strokeOpacity: 1,
    strokeWidth: 1.8,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.909a1958568517a4325fc87c3c291c82.svg";
export { ForwardRef as ReactComponent };